import { Controller } from 'stimulus'

export default class extends Controller {
  switch(event) {
    const form = this.element.querySelector('form')
    if (form) {
      // Save current note immediately before navigating
      fetch(form.action, {
        method: "PATCH",
        body: new FormData(form),
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
    }
    // Turbo frame link handles the navigation naturally
  }
}
